// Transparently redirect API calls to local backend when running on localhost
if (typeof window !== 'undefined' && !(window as any).__api_intercepted) {
  (window as any).__api_intercepted = true;
  const originalFetch = window.fetch;
  window.fetch = async function (input: RequestInfo | URL, init?: RequestInit) {
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (isLocal) {
      const localApi = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000';
      if (typeof input === 'string' && input.startsWith('https://api.tradearaidee.com')) {
        input = input.replace('https://api.tradearaidee.com', localApi);
      } else if (input instanceof URL && input.origin === 'https://api.tradearaidee.com') {
        input = new URL(input.pathname + input.search, localApi);
      }
    }
    return originalFetch(input, init);
  };
}

export {};
